import axios from "axios";
export const viewRuleSetting = async function () {
    let viewRuleSetting = {
      waterId: '',
      viewType: '',
      usageViewTimeUnit: 'day',
      volumeViewTimeUnit: 'day',
      immutable: false
    };
  
    let reqWaterId = JSON.parse(localStorage.getItem('currentProfile')).waterId;
  
    try {
      const response = await axios.get('/api/system/queryViewRuleSetting?waterId=' + reqWaterId);
      viewRuleSetting = response.data;
      return viewRuleSetting;
    } catch (error) {
      console.error('Error fetching data:', error);
      return viewRuleSetting; // Or handle the error as needed.
    }
  };
